webpackJsonp([122353984331245],{

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Cta;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cta() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bg-licorice' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'l', sizeM: 'xl', position: 'top', type: 'padding' },
	        _react2.default.createElement(
	          _align2.default,
	          { type: 'center' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', position: 'bottom', type: 'margin' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'm', sizeM: '0', position: 'leftRight', type: 'padding' },
	              _react2.default.createElement(
	                _maxWidth2.default,
	                { value: 760 },
	                _react2.default.createElement(
	                  _heading2.default,
	                  { size: 'xxxl', weight: 'semibold', color: 'white' },
	                  'Make design your company\'s competitive edge.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/enterprise' },
	            _react2.default.createElement(
	              _button2.default,
	              { shape: 'rounded', size: 'large' },
	              'Discover Marvel Enterprise'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CustomerStory;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _generalModule = __webpack_require__(733);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomerStory(_ref) {
	  var url = _ref.url,
	      image = _ref.image,
	      title = _ref.title,
	      logo = _ref.logo;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    url ? _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.hover },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: url },
	        _react2.default.createElement(
	          _link2.default,
	          { type: 'light' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', position: 'bottom', type: 'margin' },
	            _react2.default.createElement(
	              'div',
	              { className: _generalModule2.default.imageHover },
	              _react2.default.createElement(_Image2.default, _extends({}, image, { maxWidth: '100%', hasShadow: false }))
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', position: 'bottom', type: 'margin' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { tag: 'div', size: 'l' },
	              title
	            )
	          ),
	          logo
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(_Image2.default, _extends({}, image, { maxWidth: '100%', hasShadow: false }))
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { tag: 'div', size: 'l' },
	          title
	        )
	      ),
	      logo
	    )
	  );
	}
	
	CustomerStory.propTypes = {
	  url: _propTypes2.default.string,
	  image: _propTypes2.default.object,
	  title: _propTypes2.default.string,
	  logo: _propTypes2.default.node
	};
	module.exports = exports['default'];

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hover":"src-components-modules-CustomerStory-style----general-module---hover---213Cb transitionTimingFunction-cv-easeOutCircular transitionDuration-xl","imageHover":"src-components-modules-CustomerStory-style----general-module---imageHover---3fj83 overflow-hidden textAlign-center breakPointM-textAlign-left"};

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BuzzfeedFull = __webpack_require__(183);
	
	var _BuzzfeedFull2 = _interopRequireDefault(_BuzzfeedFull);
	
	var _CabifyFull = __webpack_require__(185);
	
	var _CabifyFull2 = _interopRequireDefault(_CabifyFull);
	
	var _cookpadFull = __webpack_require__(197);
	
	var _cookpadFull2 = _interopRequireDefault(_cookpadFull);
	
	var _DeliverooFull = __webpack_require__(186);
	
	var _DeliverooFull2 = _interopRequireDefault(_DeliverooFull);
	
	var _DesignMuseumFull = __webpack_require__(187);
	
	var _DesignMuseumFull2 = _interopRequireDefault(_DesignMuseumFull);
	
	var _HudlFull = __webpack_require__(188);
	
	var _HudlFull2 = _interopRequireDefault(_HudlFull);
	
	var _LaboratoriaFull = __webpack_require__(189);
	
	var _LaboratoriaFull2 = _interopRequireDefault(_LaboratoriaFull);
	
	var _ModeFull = __webpack_require__(191);
	
	var _ModeFull2 = _interopRequireDefault(_ModeFull);
	
	var _MonzoFull = __webpack_require__(192);
	
	var _MonzoFull2 = _interopRequireDefault(_MonzoFull);
	
	var _NokiaFull = __webpack_require__(193);
	
	var _NokiaFull2 = _interopRequireDefault(_NokiaFull);
	
	var _YieldrFull = __webpack_require__(195);
	
	var _YieldrFull2 = _interopRequireDefault(_YieldrFull);
	
	var _TrusonaFull = __webpack_require__(194);
	
	var _TrusonaFull2 = _interopRequireDefault(_TrusonaFull);
	
	var _ZincFull = __webpack_require__(196);
	
	var _ZincFull2 = _interopRequireDefault(_ZincFull);
	
	var _buzzfeed2x = __webpack_require__(864);
	
	var _buzzfeed2x2 = _interopRequireDefault(_buzzfeed2x);
	
	var _cabify2x = __webpack_require__(865);
	
	var _cabify2x2 = _interopRequireDefault(_cabify2x);
	
	var _cookpad2x = __webpack_require__(866);
	
	var _cookpad2x2 = _interopRequireDefault(_cookpad2x);
	
	var _deliveroo2x = __webpack_require__(867);
	
	var _deliveroo2x2 = _interopRequireDefault(_deliveroo2x);
	
	var _designMuseum2x = __webpack_require__(868);
	
	var _designMuseum2x2 = _interopRequireDefault(_designMuseum2x);
	
	var _laboratoria2x = __webpack_require__(870);
	
	var _laboratoria2x2 = _interopRequireDefault(_laboratoria2x);
	
	var _hudl2x = __webpack_require__(869);
	
	var _hudl2x2 = _interopRequireDefault(_hudl2x);
	
	var _mode2x = __webpack_require__(871);
	
	var _mode2x2 = _interopRequireDefault(_mode2x);
	
	var _monzo2x = __webpack_require__(872);
	
	var _monzo2x2 = _interopRequireDefault(_monzo2x);
	
	var _nokiaHero = __webpack_require__(415);
	
	var _nokiaHero2 = _interopRequireDefault(_nokiaHero);
	
	var _yieldr2x = __webpack_require__(874);
	
	var _yieldr2x2 = _interopRequireDefault(_yieldr2x);
	
	var _trusona2x = __webpack_require__(873);
	
	var _trusona2x2 = _interopRequireDefault(_trusona2x);
	
	var _zinc2x = __webpack_require__(875);
	
	var _zinc2x2 = _interopRequireDefault(_zinc2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerStoriesItems = [{
	  id: 0,
	  title: 'How Nokia uses Marvel to collaborate effectively across global teams',
	  logo: _react2.default.createElement(_NokiaFull2.default, { size: 90 }),
	  image: {
	    alt: 'How Nokia uses Marvel to collaborate effectively across global teams',
	    src: _nokiaHero2.default
	  },
	  url: '/case-studies/nokia'
	}, {
	  id: 1,
	  title: 'How Cabify closed design feedback loops to 15 minutes with Marvel',
	  logo: _react2.default.createElement(_CabifyFull2.default, { size: 90 }),
	  image: {
	    alt: 'How Cabify closed design feedback loops to 15 minutes with Marvel',
	    src: _cabify2x2.default
	  },
	  url: '/case-studies/cabify'
	}, {
	  id: 2,
	  title: 'How Marvel keeps Monzo shipping every two weeks',
	  logo: _react2.default.createElement(_MonzoFull2.default, { size: 90 }),
	  image: {
	    alt: 'How Marvel keeps Monzo shipping every two weeks',
	    maxWidth: 362,
	    src: _monzo2x2.default
	  },
	  url: '/case-studies/monzo'
	}, {
	  id: 3,
	  title: "How Buzzfeed's design team created a single source of truth with Marvel",
	  logo: _react2.default.createElement(_BuzzfeedFull2.default, { size: 90 }),
	  image: {
	    alt: "How Buzzfeed's design team created a single source of truth with Marvel",
	    src: _buzzfeed2x2.default
	  },
	  url: '/case-studies/buzzfeed'
	}, {
	  id: 4,
	  title: 'How Hudl drive great UX through daily user testing with Marvel',
	  logo: _react2.default.createElement(_HudlFull2.default, { size: 80 }),
	  image: {
	    alt: 'How Hudl drive great UX through daily user testing with Marvel',
	    src: _hudl2x2.default
	  },
	  url: '/case-studies/hudl'
	}, {
	  id: 5,
	  title: 'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
	  logo: _react2.default.createElement(_YieldrFull2.default, { size: 70 }),
	  image: {
	    alt: 'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
	    maxWidth: 362,
	    src: _yieldr2x2.default
	  },
	  url: '/case-studies/yieldr'
	}, {
	  id: 6,
	  title: 'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
	  logo: _react2.default.createElement(_TrusonaFull2.default, null),
	  image: {
	    alt: 'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
	    maxWidth: 362,
	    src: _trusona2x2.default
	  },
	  url: '/case-studies/trusona'
	}, {
	  id: 7,
	  title: 'Why Zinc introduces Marvel to their incubator startups',
	  logo: _react2.default.createElement(_ZincFull2.default, null),
	  image: {
	    alt: 'Why Zinc introduces Marvel to their incubator startups',
	    maxWidth: 362,
	    src: _zinc2x2.default
	  },
	  url: '/case-studies/zinc'
	}, {
	  id: 8,
	  title: 'How Cookpad uses Marvel to tackle the big risks in product design, early on.',
	  logo: _react2.default.createElement(_cookpadFull2.default, { width: 120, height: 35 }),
	  image: {
	    alt: 'How Cookpad uses Marvel to tackle the big risks in product design, early on.',
	    maxWidth: 362,
	    src: _cookpad2x2.default
	  },
	  url: '/case-studies/cookpad'
	}, {
	  id: 9,
	  title: 'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
	  logo: _react2.default.createElement(_DesignMuseumFull2.default, { width: 65, height: 50 }),
	  image: {
	    alt: 'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
	    maxWidth: 362,
	    src: _designMuseum2x2.default
	  },
	  url: '/case-studies/designmuseum'
	}, {
	  id: 10,
	  title: 'How Laboratoria’s students foster learning in design with Marvel',
	  logo: _react2.default.createElement(_LaboratoriaFull2.default, { size: 130 }),
	  image: {
	    alt: 'How Laboratoria’s students foster design learning in design with Marvel',
	    maxWidth: 362,
	    src: _laboratoria2x2.default
	  },
	  url: '/case-studies/laboratoria'
	}, {
	  id: 11,
	  title: 'How Marvel Handoff transformed Mode’s design to development communication',
	  logo: _react2.default.createElement(_ModeFull2.default, null),
	  image: {
	    alt: 'How Marvel Handoff transformed Mode’s design to development communication',
	    maxWidth: 400,
	    src: _mode2x2.default
	  },
	  url: '/case-studies/mode'
	}, {
	  id: 12,
	  title: 'How Deliveroo speed up iteration and drive great design with Marvel',
	  logo: _react2.default.createElement(_DeliverooFull2.default, { size: 100 }),
	  image: {
	    alt: 'How Deliveroo speed up iteration and drive great design with Marvel',
	    src: _deliveroo2x2.default
	  },
	  url: '/case-studies/deliveroo'
	}];
	
	exports.default = customerStoriesItems;
	module.exports = exports['default'];

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/buzzfeed@2x-f3fe92c65444fdd24722645ecfe2e4f7.jpg";

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cabify@2x-41442eacccf4f94dcff4b536bdc56e99.jpg";

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cookpad@2x-f3293bd476116497a90399a136bb74c8.jpg";

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/deliveroo@2x-21cd0f4b870cc38b2f5b9a413beccbac.jpg";

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/design-museum@2x-e53ef5703c8c78a76735c259ea7e4b17.jpg";

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hudl@2x-1488e5bddc7e57eb0685f01294f587b5.jpg";

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/laboratoria@2x-1c8ef56fd28b6436fd783372bd122fe1.png";

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mode@2x-e8042bf00e80e79002a4e42ffd6d35f3.jpg";

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo@2x-50aff407137e0baf2d62364a4b47e102.jpg";

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trusona@2x-f22f6ec899e120169cf29370801faaa3.jpg";

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yieldr@2x-3692cfef2020f4587d1d45e0f8f80811.jpg";

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/zinc@2x-64d071bf19b4837936d3eda96ef1760e.jpg";

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Stories;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _CustomerStory = __webpack_require__(566);
	
	var _CustomerStory2 = _interopRequireDefault(_CustomerStory);
	
	var _customerStoriesItems = __webpack_require__(612);
	
	var _customerStoriesItems2 = _interopRequireDefault(_customerStoriesItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Stories() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'margin' },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 6, size: 'l', sizeM: 'xl', alignItems: 'center' },
	        _customerStoriesItems2.default.map(function (item) {
	          return _react2.default.createElement(
	            _grid.GridItem,
	            {
	              key: item.id,
	              columnSpan: 6,
	              columnSpanS: 3,
	              columnSpanM: 2
	            },
	            _react2.default.createElement(_CustomerStory2.default, {
	              image: item.image,
	              logo: item.logo,
	              title: item.title,
	              url: item.url
	            })
	          );
	        })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = CustomerStoriesMain;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _HeroSkinny = __webpack_require__(148);
	
	var _HeroSkinny2 = _interopRequireDefault(_HeroSkinny);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _CtaStories = __webpack_require__(565);
	
	var _CtaStories2 = _interopRequireDefault(_CtaStories);
	
	var _Stories = __webpack_require__(1259);
	
	var _Stories2 = _interopRequireDefault(_Stories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageProps = {
	  title: 'Customer Stories | Marvel',
	  meta: [{
	    name: 'description',
	    content: "Find out how we're helping the world's most innovative companies democritise design"
	  }, { name: 'keywords', content: 'case study, customer stories' }],
	  header: true,
	  banner: true,
	  footer: true
	};
	
	function CustomerStoriesMain() {
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(_HeroSkinny2.default, {
	      center: true,
	      tag: 'h1',
	      maxWidth: 900,
	      title: 'Marvel helps build stronger companies by democratising design and making it more productive'
	    }),
	    _react2.default.createElement(_Stories2.default, null),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { maxWidth: 769 },
	      _react2.default.createElement(_Whitespace2.default, { size: 'm' })
	    ),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { minWidth: 770 },
	      _react2.default.createElement(_Whitespace2.default, { size: 'xl' })
	    ),
	    _react2.default.createElement(_CtaStories2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-customer-stories-index-js-ad06f811e847c7e4a6e3.js